import Cookies from 'js-cookie';
import * as types from '../mutation-types';

// state
export const state = {
  user: null,
  token: Cookies.get('token'),
  permissions: null,
  params: null,
};

// getters
export const getters = {
  user: (state) => state.user,
  token: (state) => state.token,
  check: (state) => state.user !== null,
  permissions: (state) => state.permissions,
  params: (state) => state.params,
};

// mutations
export const mutations = {
  [types.SAVE_TOKEN](state, { token, remember }) {
    state.token = token;
    Cookies.set('token', token, remember ? { expires: 365 } : {});
    // Cada nuevo inicio de sesión debe volver a mostrar el modal de
    // notificaciones pendientes en el Home.
    sessionStorage.removeItem('notify_modal_shown');
  },

  [types.FETCH_USER_SUCCESS](state, { user }) {
    state.user = user.user;
    state.permissions = user.permission;
  },

  [types.FETCH_PARAMS_SUCCESS](state, { params }) {
    state.params = params;
  },

  [types.FETCH_USER_FAILURE](state) {
    state.token = null;
    Cookies.remove('token');
  },

  [types.LOGOUT](state) {
    state.user = null;
    state.token = null;

    Cookies.remove('token');
    sessionStorage.removeItem('notify_modal_shown');
  },

  [types.UPDATE_USER](state, { user }) {
    state.user = user;
  },
};

// actions
export const actions = {
  saveToken({ commit }, payload) {
    commit(types.SAVE_TOKEN, payload);
  },

  async fetchUser({ commit }) {
    try {
      const { data } = await window.axios.get('/api/user');

      commit(types.FETCH_USER_SUCCESS, { user: data });
    } catch (e) {
      commit(types.FETCH_USER_FAILURE);
    }
  },

  async fetchParams({ commit }) {
    try {
      const { data } = await window.axios.get('/api/designParams');
      commit(types.FETCH_PARAMS_SUCCESS, { params: data });
    } catch (e) {
      commit(types.FETCH_PARAMS_FAILURE);
    }
  },

  updateUser({ commit }, payload) {
    commit(types.UPDATE_USER, payload);
  },

  async logout({ commit }) {
    try {
      await window.axios.post('/api/logout');
    } catch (e) {
      this.$store.dispatch('notifications/show', {
        message: e,
        type: 'error',
      });
    }

    commit(types.LOGOUT);
  },

  async fetchOauthUrl(ctx, { provider }) {
    const { data } = await window.axios.post(`/api/oauth/${provider}`);

    return data.url;
  },
};
